/* eslint-disable no-unused-vars */
import { getUserToken } from '../utils/auth.utils';

let headers;
let baseURL;
let logFormat;
let client;
let crossDomain;
let log;
let debug;

/**
 *
 * Setup wrapper request configuration.
 * @param config
 */
export const setUp = ({
  baseURL: aBaseURL,
  headers: aHeaders,
  logFormat: aLogFormat,
  client: aClient,
  crossDomain: aCrossDomain,
  log: aLog,
  debug: aDebug,
}) => {
  baseURL = aBaseURL;
  headers = aHeaders;
  logFormat = aLogFormat || 'full';
  client = aClient;
  crossDomain = aCrossDomain;
  log = aLog;
  debug = aDebug;
};

export const clearAuthorization = () => {
  delete headers.Authorization;
  delete headers.authorization;
};

/**
 *
 * Create the headers.
 * @returns {*}
 */
export const createHeaders = () => {
  const token = getUserToken();
  delete headers.Authorization;
  return Object.assign(headers || {}, typeof window !== 'undefined' && token && { Authorization: `Bearer ${token}` });
};

/**
 *
 * Create the base URL.
 * @returns {*}
 */
export const createBaseURL = () => baseURL;

/**
 *
 * Create the base URL.
 * @returns {*}
 */
export const getLogFormat = () => logFormat;

/**
 *
 * Get client created
 * @returns {*}
 */
export const getClient = () => client;

/**
 *
 * Get CrossDomain created
 * @returns {*}
 */
export const getCrossDomain = () => crossDomain;

/**
 *
 * Get Logger
 * @returns {*}
 */
export const getLog = () => log;

/**
 *
 * Debug mode
 * @returns {Boolean} debug activation status
 */
export const getDebug = () => debug;
